<template>
    <div id="chat_container" class="chat-container ">
                <div class="chat-box ">
                    <div class="chat-header">
                        <div class="flex-left" >
                            <div class="profile-image">
                                <img alt="profile image" src="https://storeno.b-cdn.net/shipsen/1-2022/1642680400586.jpeg">
                                <div class="account-status"></div>
                            </div>
                            <p class="chat-title">{{'livechat shippsen Support'}}</p>
                        </div>    
                        <div class="close-icon" @click="hidepop()">
                            <span class="bar"></span>
                            <span class="bar"></span>
                        </div>
                    </div>
                    <div class="messages-box scroll-box" id="messages-scroll-box">
                        
                        <div class="msg" v-for="(item,index) in messages" :key="index" >
                            <!-- <div class="shep"  v-if="chekAdmin(item.admin)==true">
                                <img alt="profile image" src="https://storeno.b-cdn.net/shipsen/1-2022/1642680400586.jpeg">
                            </div> -->
                           <Message  :item="item" :position="item.admin ?'leftfollow':'rightfollow'" v-on:showImg="showImg($event)" v-on:remove="deleteMessage($event)"/>
                        </div>

                        <div v-if="uploadedImages.length>0" class="uploader-image">
                        <div class="images-slied scroll-box" id="messages-scroll-box">
                        <img v-for="(img, index) in uploadedImages" :key="index" :src="img" alt="uploaded image">
                        </div>
                                <div class="actions">
                                    <div @click="closePopImg()" class="close-icon">
                                        <span class="bar"></span>
                                        <span class="bar"></span>
                                    </div>

                                <button @click.prevent="sendMessage('image')" v-if="true" class="send-button send-button-img">
                                    <span>
                                        <svg viewBox="0 0 24 24" width="22" height="22"><path fill="#5d86a1" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path></svg>
                                    </span>
                                    <div v-if="cdnloader" class="loader"></div>
                                </button>
                                </div>
                        </div>
                    </div>
                    <div v-if="true || sendBox" class="container-send-box">
                        <div class="wrapper">
                                <div class="file-upload">
                                    <input type="file" accept=".png, .jpg, .jpeg" @change="uploadImage($event)" id="input-image" multiple>
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="21" height="21" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m432 0h-352c-44.113281 0-80 35.886719-80 80v280c0 44.113281 35.886719 80 80 80h273c11.046875 0 20-8.953125 20-20s-8.953125-20-20-20h-73.664062l-45.984376-59.65625 145.722657-185.347656 98.097656 108.421875c5.546875 6.136719 14.300781 8.21875 22.019531 5.246093 7.714844-2.976562 12.808594-10.394531 12.808594-18.664062v-170c0-44.113281-35.886719-80-80-80zm40 198.085938-79.167969-87.503907c-3.953125-4.371093-9.640625-6.785156-15.523437-6.570312-5.886719.207031-11.386719 2.996093-15.03125 7.628906l-154.117188 196.023437-52.320312-67.875c-3.785156-4.910156-9.636719-7.789062-15.839844-7.789062-.003906 0-.007812 0-.011719 0-6.203125.003906-12.058593 2.886719-15.839843 7.804688l-44.015626 57.21875c-6.734374 8.757812-5.097656 21.3125 3.65625 28.046874 8.757813 6.738282 21.3125 5.097657 28.050782-3.65625l28.175781-36.632812 88.816406 115.21875h-148.832031c-22.054688 0-40-17.945312-40-40v-280c0-22.054688 17.945312-40 40-40h352c22.054688 0 40 17.945312 40 40zm0 0" fill="#7e7e7e" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m140 72c-33.085938 0-60 26.914062-60 60s26.914062 60 60 60 60-26.914062 60-60-26.914062-60-60-60zm0 80c-11.027344 0-20-8.972656-20-20s8.972656-20 20-20 20 8.972656 20 20-8.972656 20-20 20zm0 0" fill="#7e7e7e" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m468.476562 302.941406c-.058593-.058594-.117187-.121094-.175781-.179687-9.453125-9.519531-22.027343-14.761719-35.410156-14.761719-13.34375 0-25.882813 5.210938-35.324219 14.675781l-38.613281 38.085938c-7.863281 7.753906-7.949219 20.417969-.191406 28.28125 7.753906 7.863281 20.417969 7.953125 28.28125.195312l25.847656-25.492187v112.253906c0 11.046875 8.953125 20 20 20s20-8.953125 20-20v-111.644531l24.738281 25.554687c3.921875 4.054688 9.144532 6.089844 14.371094 6.089844 5.011719 0 10.027344-1.871094 13.910156-5.628906 7.9375-7.683594 8.140625-20.34375.457032-28.28125zm0 0" fill="#7e7e7e" data-original="#000000" style="" class=""/></g></svg>
                                </div>
                        </div>
                        <span class="intra-space"></span>
                        <div class="bg-col">
                            <form class="message-send-box" >
                                <!-- <input class="message-send" dir="auto" type="text" v-model="message" @blur="userBlur()" @focus="userTyping('text')" :placeholder="'livechat_typeAMessage'" /> -->
                                <input autofocus dir="auto" id="text-input" class="message-send" type="text"  v-model="message" @blur="userBlur()" @focus="userTyping('text')" :placeholder="'livechat_typeAMessage'  " />
                                <span class="intra-space"></span>
                                <button v-if="message!==''" @click.prevent="sendMessage('text')"  class="send-button absolute-r-2">
                                        <span v-html="getsvg('sendBtn')"></span>
                                        <div v-if="cdnloader" class="loader"></div>
                                </button>
                            </form>
                        <div v-if="message==''" :class="{'record-actions':recordState=='send'}">                          

                                <button v-if="recordState=='send' && recordedon" @click="removeRecord()" class="send-button remove-audio">
                                  <svg data-v-388c3261="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-5" style="color: rgb(239, 104, 104);"><path data-v-388c3261="" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                                </button>

                                <div v-if="message=='' && recordState=='send'" class="timer-container">
                                    <span class="timer-circle" :class="{'bounce-animation':bounceAnimation}"></span>
                                    <span class="timer"> {{recordTimer.minutes +':'+ recordTimer.seconds}}</span> 
                                </div>

                                <button v-if="message=='' && !isMobile" id="d-record-button" @click="record()" class="send-button" :class="{'bs2b':recordState=='send'}">
                                        <svg v-if="recordState=='send'" id="d-record-svg" width="16" height="12" viewBox="0 0 16 12" fill="#61AFC7" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.52501 11.657L0.575012 6.70699L1.78203 5.49997L5.35453 8.99847L5.49832 9.14526L14.167 0.499969L15.424 1.75699L6.93901 10.243L5.52601 11.656L5.52501 11.657Z"/>
                                        </svg>
                                        <svg v-else  style="fill:#4F5458;" id="d-record-svg" viewBox="0 0 24 24" width="21" height="21" class=""><path d="M11.999 14.942c2.001 0 3.531-1.53 3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531S8.469 2.35 8.469 4.35v7.061c0 2.001 1.53 3.531 3.53 3.531zm6.238-3.53c0 3.531-2.942 6.002-6.237 6.002s-6.237-2.471-6.237-6.002H3.761c0 4.001 3.178 7.297 7.061 7.885v3.884h2.354v-3.884c3.884-.588 7.061-3.884 7.061-7.885h-2z"></path></svg>
                                        <div v-if="cdnloader" class="loader"></div>
                                </button>
                                <button v-if="message=='' && isMobile && !toSend" id="m-record-button" @mousedown="startRecord()" @mouseup="stopRecord()" class="send-button" :class="[{'bs2b':recordState=='send'},{'record-animation':recordAnimation}]">
                                        <svg v-if="recordState=='send'" id="m-record-svg" width="16" height="12" viewBox="0 0 16 12" fill="#61AFC7" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.52501 11.657L0.575012 6.70699L1.78203 5.49997L5.35453 8.99847L5.49832 9.14526L14.167 0.499969L15.424 1.75699L6.93901 10.243L5.52601 11.656L5.52501 11.657Z"/>
                                        </svg>
                                        <svg v-else style="fill:#4F5458;" id="m-record-svg" viewBox="0 0 24 24" width="21" height="21" class=""><path d="M11.999 14.942c2.001 0 3.531-1.53 3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531S8.469 2.35 8.469 4.35v7.061c0 2.001 1.53 3.531 3.53 3.531zm6.238-3.53c0 3.531-2.942 6.002-6.237 6.002s-6.237-2.471-6.237-6.002H3.761c0 4.001 3.178 7.297 7.061 7.885v3.884h2.354v-3.884c3.884-.588 7.061-3.884 7.061-7.885h-2z"></path></svg>
                                        <div v-if="cdnloader" class="loader"></div>
                                </button>
                                <button v-if="message=='' && isMobile && toSend" id="m-record-button" @click="sendAudio()" class="send-button" :class="{'bs2b':recordState=='send'}">
                                        <svg v-if="recordState=='send'" id="m-record-svg" width="16" height="12" viewBox="0 0 16 12" fill="rgb(97 175 199);" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.52501 11.657L0.575012 6.70699L1.78203 5.49997L5.35453 8.99847L5.49832 9.14526L14.167 0.499969L15.424 1.75699L6.93901 10.243L5.52601 11.656L5.52501 11.657Z"/>
                                        </svg>
                                        <svg v-else style="fill:#4F5458;" id="m-record-svg" viewBox="0 0 24 24" width="21" height="21" class=""><path d="M11.999 14.942c2.001 0 3.531-1.53 3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531S8.469 2.35 8.469 4.35v7.061c0 2.001 1.53 3.531 3.53 3.531zm6.238-3.53c0 3.531-2.942 6.002-6.237 6.002s-6.237-2.471-6.237-6.002H3.761c0 4.001 3.178 7.297 7.061 7.885v3.884h2.354v-3.884c3.884-.588 7.061-3.884 7.061-7.885h-2z"></path></svg>
                                        <div v-if="cdnloader" class="loader"></div>
                                </button>
                              </div>
                        </div>
                    </div>
                </div>
        </div>
</template>
<script>
import Message from './Message.vue'
const recordAudio = () => {
    return new Promise(resolve => {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          const mediaRecorder = new MediaRecorder(stream);
          var audioChunks = [];
  
          mediaRecorder.addEventListener("dataavailable", event => {
            audioChunks.push(event.data);
          });
  
          const start = () => {
            mediaRecorder.start();
          };
          const stop = () => {
            return new Promise(resolve => {
              mediaRecorder.addEventListener("stop", () => {
                const audioBlob = new Blob(audioChunks,{type: 'audio/mp3'});
                const audioUrl = URL.createObjectURL(audioBlob);
                const audio = new Audio(audioUrl);
                audioChunks=[]
                const play = ()=>{
                    audio.play()
                }
                resolve({ audioBlob, audioUrl,audio, play });
              });
              mediaRecorder.stop();
            });
          };
  
          resolve({ start, stop });
        });
    });
  };
export default {
      props:[
       'store',
       'chatPopIsShowed',
       'warehouse'
      ],
      components :{Message},
      data(){
          return{
                recordTimer:{minutes:'00',seconds:'00'},
                messageOptions:false,
                cdnloader:false,
                audio:null,
                showIconAdmin:0,
                uploadedImages:[],
                currentImage:null,
                "unreadedMessages": 0,
                "visitorName": "",
                App: null,
                "visitor": "",
                "visitOnValue":"",
                "messages": [],
                "messagesListenner": "",
                "message": '',
                recorder:null,
                recordedAudio:null,
                recordState:'start',
                intervalTime:null,
                isMobile:false,
                device:'descktop',
                audioLength:0,
                recordedon:true,
                bounceAnimation:false,
                recordAnimation:false,
                toSend:false,
                sendBox:false,
                waiting:false,
                ready:false,
                visitorKey:null,
                nofification:null,
                step:0,
                userData:null
          }
      },
    async mounted() { 
        this.userData=await this.$me
        if(window.innerWidth<=425){
            this.isMobile=true
            this.device='mobile'
        }
        await this.importfarebase()
    },
    watch: {
        chatPopIsShowed:{
            handler() {
                this.$nextTick(() => {
                    if(this.step!=5) return false
                    if (this.chatPopIsShowed) {
                        if (document.getElementById('messages-scroll-box') !== null) {
                            let scrollBox = document.getElementById('messages-scroll-box');
                            scrollBox.scrollTop = scrollBox.scrollHeight;
                        }
                        this.unreadedMessages = 0
                        this.$emit('unreadedMessages', this.unreadedMessages)
                        this.App.database()
                            .ref("messages/" + this.visitorKey)
                            .orderByChild("readedByVisitor")
                            .equalTo(false)
                            .once("value", (results) => {
                                results.forEach((snapshot) => {
                                    snapshot.ref.update({
                                        readedByVisitor: true
                                    });
                                });
                            });
                        
                    }
                })
            }
        },
       async step(){
            if (this.step==4) {
                
                    await this.init()
                    this.step=5
                    this.startConversation()
                    //     setTimeout(async() => {                
                    //         try {

                    //         } catch (error) {console.log(error);}
                    // },4000)   
            }
        }
    },
    methods: {
        userTyping(type){
            if (this.visitorKey) {
                let key = this.visitorKey
                let data = {
                    isFocused : true,
                    focusedType : type,
                    // focusedBy : this.userData.content
                }
                this.App.database().ref(`visitors/${key}/focused`).set(data)
            }
        },
        userBlur(){
            if (this.visitorKey) {
                let key = this.visitorKey
                let data = {
                    isFocused : false,
                }
                this.App.database().ref(`visitors/${key}/focused`).set(data)
            }
        },
        importfarebase(){
            let firebasecdn = document.createElement('script')
            let databasecdn = document.createElement('script')
            let fbauthcdn = document.createElement('script')
            let cryptoAES = document.createElement('script')
            firebasecdn.src = "https://www.gstatic.com/firebasejs/7.17.1/firebase-app.js"
            databasecdn.src = "https://www.gstatic.com/firebasejs/7.17.1/firebase-database.js"
            fbauthcdn.src = "https://www.gstatic.com/firebasejs/7.17.1/firebase-auth.js"
            cryptoAES.src = "https://cdnjs.cloudflare.com/ajax/libs/crypto-js/3.1.2/rollups/aes.js"
            this.nofification = new Audio(require('../../assets/ringtone/sound.mp3'))
            document.head.appendChild(firebasecdn)
            document.head.appendChild(databasecdn)
            document.head.appendChild(fbauthcdn)
            document.head.appendChild(cryptoAES)
            firebasecdn.onload=()=>{ this.step+=1}
            databasecdn.onload=()=>{ this.step+=1}
            fbauthcdn.onload=()=>{ this.step+=1}
            cryptoAES.onload=()=>{ this.step+=1}
        },
        async init(){

            let decryptedPack = {}
            let fbdecryptedPack = {}

                decryptedPack = {
                    email: "shipsen105@gmail.com",
                    password: "123456789"
                }
            fbdecryptedPack={
                apiKey: "AIzaSyA0qVQZaLFUAN-8SFmh4FZuh8eHtgbgJeo",
                authDomain: "livechat-shipsen.firebaseapp.com",
                projectId: "livechat-shipsen",
                storageBucket: "livechat-shipsen.appspot.com",
                messagingSenderId: "985414755139",
                databaseURL: "https://livechat-shipsen-default-rtdb.firebaseio.com",
                appId: "1:985414755139:web:fa32eca49254dc49f905f6",
                measurementId: "G-0TP8LJ5KM8"
            }




                //   decryptedPack = {
                //     email: "hamzaallaa00@gmail.com",
                //     password: "123456789hamza"
                // }
                // fbdecryptedPack = {
                //     apiKey: "AIzaSyBdDbyg1jKYfvAqQln6ape8pRmqp7vh7lU",
                //     authDomain: "livechatshipsen.firebaseapp.com",
                //     projectId: "livechatshipsen",
                //     storageBucket: "livechatshipsen.appspot.com",
                //     databaseURL: "https://livechatshipsen-default-rtdb.firebaseio.com",
                //     messagingSenderId: "137527517238",
                //     appId: "1:137527517238:web:772351e906e652d055b897",
                //     measurementId: "G-JF8TFYMY5Q"
                // };   
            await this.getfirebase(fbdecryptedPack)
            this.App = firebase   
            return new Promise(resolve => {
                firebase.auth().signInWithEmailAndPassword(decryptedPack.email,decryptedPack.password)
                    .then((userCredential) => {
                        var user = userCredential.user;
                    })
                    .catch((error) => console.log(error));
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {  
                        this.firebaseUserId =user.uid;
                        resolve(user.uid);
                    } else {}
                });
            });           
        },
        async record(){
           try {
                switch(this.recordState){
                case 'start':{
                    this.recordState="send"
                    this.recorder = await recordAudio();
                    await this.recorder.start();
                    this.userTyping('audio')
                    this.bounceAnimation=true
                    // document.querySelector('#d-record-svg').style.fill="#FFF"
                    // document.querySelector('#d-record-button').classList.add("record-animation")
                    var start = new Date().getTime();
                    this.intervalTime = setInterval(()=>{
                        let distance = (new Date().getTime() - start )
                        let minutes = Math.floor(distance/(1000*60))
                        let seconds = Math.floor((distance/1000)-(minutes*60))
                        minutes = minutes < 10 ? '0'+minutes:minutes
                        seconds = seconds < 10 ? '0'+seconds:seconds
                        this.recordTimer={minutes:minutes,seconds:seconds}
                    } ,1000);
                    break
                }
                case 'send':{
                    this.bounceAnimation=false
                    this.recordState="start"
                    this.userBlur()
                    clearInterval(this.intervalTime)
                    this.recordTimer.minutes='00'
                    this.recordTimer.seconds='00'
                    const audio = await this.recorder.stop();
                    this.audio = await this.audioToBase64(audio.audioBlob)
                    this.sendMessage('audio')                   
                    break
                }
            }
           } catch (error) {
               console.log(error);
           }
        },
        async sendAudio(){
           try {
                this.recordState="start"
                clearInterval(this.intervalTime)
                this.recordTimer.minutes='00'
                this.recordTimer.seconds='00'
                this.sendMessage('audio') 
                this.toSend=false
                this.userBlur()
           } catch (error) {
               console.log(error);
           }
        },
        async startRecord(){
           try {
                this.recordedon=false
                this.bounceAnimation=true
                this.recordAnimation=true
                this.recordState="send"
                this.recorder = await recordAudio();
                await this.recorder.start();
                document.querySelector('#m-record-svg').style.fill="#FFF"
                var start = new Date().getTime();
                this.intervalTime = setInterval(()=>{
                    this.audioLength = (new Date().getTime() - start )
                    let minutes = Math.floor(this.audioLength/(1000*60))
                    let seconds = Math.floor((this.audioLength/1000)-(minutes*60))
                    minutes = minutes < 10 ? '0'+minutes:minutes
                    seconds = seconds < 10 ? '0'+seconds:seconds
                    this.recordTimer={minutes:minutes,seconds:seconds}
                } ,1000);
           } catch (error) {
               console.log(error);
           }
        },
        async stopRecord(){
           try { 
                this.recordedon=true
                this.bounceAnimation=false
                this.recordAnimation=false
                document.querySelector('#m-record-svg').style.fill="#4F5458"
                clearInterval(this.intervalTime)
                if(this.audioLength<1000){             
                    this.recordState="start"
                    this.recorder = null
                    this.audio = null
                }else{
                    const audio = await this.recorder.stop();
                    this.audio = await this.audioToBase64(audio.audioBlob)
                    this.toSend=true
                }
                // this.recordState="start"

                this.audioLength=0
           } catch (error) {
               clearInterval(this.intervalTime)
               this.recordState="start"
               this.recorder = null
               this.audio = null
               this.audioLength=0
               this.recordTimer.minutes='00'
               this.recordTimer.seconds='00'
               console.log(error);
           }
        },
        async removeRecord(){
            try {
                this.userBlur()
                clearInterval(this.intervalTime)
                this.recordTimer.minutes='00'
                this.recordTimer.seconds='00'
                this.recorder=null
                this.toSend=false
                if(this.isMobile){
                    document.querySelector('#m-record-svg').style.fill="#4F5458"
                    document.querySelector('#m-record-button').classList.remove("record-animation")
                }else{
                    document.querySelector('#d-record-svg').style.fill="#4F5458"
                    document.querySelector('#d-record-button').classList.remove("record-animation")
                }
                
                this.audio=null
                this.recordState="start"
            } catch (error) {
                console.log(error);
            }
        
        },
        audioToBase64(blob) {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            return new Promise(resolve => {
                reader.onloadend = () => {
                resolve(reader.result);
                };
            });
        },    
        closePopImg(){
         this.uploadedImages=[]
        },
        hidepop() {
            this.$emit("hidepop")
        },
        showImg(src){
           this.$emit('showImg',src)
        },
        async deleteMessage(item){
            try {
                 item.isDeleted=true
                 await this.App.database()
                .ref(`messages/${item.parentKey}/${item.key}`).set(item);
            } catch (error) {
                console.log(error);
            }
        },
        async startConversation() {
            // get firebase key from back end
            setTimeout(() => {
                this.$emit('rendred')    
            }, 2000)

           try{
                 if(this.userData.content.customFields){
                      this.customFields=this.userData.content.customFields
                      if(this.userData.content.customFields.fbVisitorKey11){
                          this.visitorKey=this.userData.content.customFields.fbVisitorKey11
                          this.testMessages()                   
                      }else{
                          this.visitorKey=null
                          this.waiting=true
                          this.firstMessages()
                      }              
                 }else{
                   this.customFields=null
                   this.waiting=true
                   this.firstMessages();
                 }
            }catch(err){
                console.log("--------Error : ",err);
            }
        },
        async testMessages(){   
            // test messages
            try {
                await this.App.database().ref(`messages/${this.visitorKey}`)
                   .once("value", (snap) => {
                    if (snap.val()) {
                        this.sendBox=true
                        this.launchOld()
                    }else{
                        this.waiting=true
                        this.visitorKey=null
                        this.firstMessages()
                    }
                });
            } catch (err) {
                console.log(err)
            }                    
        },
        async launchOld(){
            try {   
                // get visitor 
                this.visitOnValue = await this.App.database()
                .ref(`visitors/${this.visitorKey}`)
                .once("value", (snap) => {
                    if (snap.val()) {
                        this.visitor = snap.val()
                    } else {
                        this.visitorKey = ''
                        this.visitor = []
                        this.messages = []
                    }      
                })
                this.messagesListenner = await this.App.database()
                .ref(`messages/${this.visitorKey}`)
                .on("child_added", (snap) => {
                    this.messages.push({...snap.val() , key:snap.ref.key,parentKey:snap.ref.parent.key});
                    if (snap.val().admin && !snap.val().readedByVisitor) { //new admin s message
                        this.nofification.play()
                        if (this.chatPopIsShowed) { // chat box is oppenned
                            this.unreadedMessages = 0
                            this.$emit('unreadedMessages', this.unreadedMessages)
                            this.App.database()
                                .ref(`messages/${this.visitorKey}`)
                                .orderByChild("readedByVisitor")
                                .equalTo(false)
                                .once("value", (results) => {
                                    results.forEach((snapshot) => {
                                        snapshot.ref.update({
                                            readedByVisitor: true
                                        });
                                    });
                                });
                    } else {
                            this.unreadedMessages += 1;
                            this.$emit('unreadedMessages', this.unreadedMessages)
                        }
                    }
                });

            } catch (error) {
                console.log(error);
            }
        },
        async sendStartMessage(type){
            this.cdnloader=true
            if (this.customFields) {
                await this.App.database() 
                    .ref(`visitors/${this.visitorKey}`)
                    .once("value", (snap) => {
                        if (snap.val()) {       // visitor with key in fb
                            this.waiting=false
                            this.launchOld()
                            this.sendMessage(type)
                            this.ready=false
                            this.sendBox=true
                            this.cdnloader=false
                        }else{                  // visitor with no key in fb        
                            this.launchNew(type)
                        }
                    });
            }else{
                this.launchNew(type)
            }         
        },
        async launchNew(type){
            let username = this.userData.content.fullName
                try {
                    var visitorInstance = await this.App.database().ref(`visitors/`).push({
                        username:username,
                        done:false,
                        warehouse:this.warehouse,
                        userId: this.userData.content._id,
                        timestamp: { '.sv': 'timestamp' },
                        isDeleted: false,
                        isMarked: false,
                        isBlocked: false,
                        customFields:{}
                    }); 
                    this.visitorKey = visitorInstance.key
                    this.waiting=false
                    this.sendMessage(type) 
                    this.launchOld()
                    this.ready=false
                    this.sendBox=true
                    this.cdnloader=false
                        this.updateFirebaseVisitorKey(this.visitorKey) 
                } catch (err) {
                    console.log(err)
                }  
        },
        async updateFirebaseVisitorKey(key,order){
            try{
                const data = await this.$server.update("users", {customFields:{"fbVisitorKey11": key},_id:this.userData.content._id} );
            }catch(err){
                console.log("--------- visitor key creation error : ",err.response);
            }
        },
        sendMessage(messageType) {

            if(this.waiting){
               this.sendStartMessage(messageType) 
               return 0
            }
            switch (messageType){
               case 'image' :{
                   this.uploadedImages.forEach(async(ele)=>{
                       this.cdnloader=true
                       let img = await this.getImageCDN(ele)
                       this.cdnloader=false
                       this.sendMessage2(messageType,img) 
                       
                   })
                   this.uploadedImages = [];
                   break;
               }
               case 'text' :{
                    if(this.message.length<1){
                       return 0
                    }
                    this.sendMessage2(messageType,this.removeTags(this.message)) 
                    this.message = "";
                    break;
               }
                case 'audio' :{
                    let x = async()=>{
                        this.cdnloader=true
                        let cdnres = await this.getAudioCDN(this.audio)
                        this.sendMessage2(messageType,cdnres)  
                        this.audio=null
                        this.cdnloader=false
                    }
                    x();
                    break;
               }
            }

        },
        async sendMessage2(type,msg){
            try {
                delete this.warehouse.id;delete this.warehouse.createdAt;delete this.warehouse.__v; delete this.warehouse.fullOf; delete this.warehouse.info;delete this.warehouse.isDeleted
                await this.App.database() //save new message
                .ref("messages/" + this.visitorKey)
                .push({
                    type:type,
                    message:msg,
                    warehouse:this.warehouse,
                    message: this.message,
                    visiorKey: this.visitorKey,
                    to: "admin",
                    timestamp: { '.sv': 'timestamp' },
                    readedByVisitor: true,
                    readedByAdmin: false,
                    type:type,
                    message:msg,
                    isDeleted:false,
                    customFields:{}
                })
                 var postData = {
                    ...this.visitor
                };
                  postData.userId= this.userData.content._id
                  postData.username = this.userData.content.fullName
                  postData.warehouse= this.warehouse
                  postData.done=false
                var updates = {};
                updates['/visitors/' + this.visitorKey] = postData;
                this.App.database().ref().update(updates);
                if (document.getElementById('messages-scroll-box') !== null) {
                            let scrollBox = document.getElementById('messages-scroll-box');
                            scrollBox.scrollTop = scrollBox.scrollHeight;
                }
            } catch (error) {
                console.log(error);
            }
        },
        removeTags(text){
            return text.replace(/(<([^>]+)>)/ig, "");
        },
        async dropconversation() {
            let confermation = confirm('are you sure');
            if (confermation) {
                var postData = {
                    ...this.visitor,
                    isDeleted: true,
                };
                await this.App.database() // stop on visitor value listenner
                    .ref("visitors/" + this.visitorKey)
                    .off("value",this.visitOnValue)
                var updates = {};
                updates['/visitors/' + this.visitorKey] = postData;
                this.App.database().ref().update(updates);
                this.messages = []
                localStorage.removeItem('visitorKey')
                localStorage.setItem('storeState', 'homeSelected')
                this.visitorName = ""
                this.chatSelected = false
            } else {}
        },
        getsvg(name) {
            if (name == "sendIcon") {
                    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="34" height="34" x="0" y="0" viewBox="0 0 34 34" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg"><g><path d="M481.508,210.336L68.414,38.926c-17.403-7.222-37.064-4.045-51.309,8.287C2.86,59.547-3.098,78.551,1.558,96.808 L38.327,241h180.026c8.284,0,15.001,6.716,15.001,15.001c0,8.284-6.716,15.001-15.001,15.001H38.327L1.558,415.193 c-4.656,18.258,1.301,37.262,15.547,49.595c14.274,12.357,33.937,15.495,51.31,8.287l413.094-171.409 C500.317,293.862,512,276.364,512,256.001C512,235.638,500.317,218.139,481.508,210.336z" fill="#183650" data-original="#000000" style=""/></g></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g><g xmlns="http://www.w3.org/2000/svg"></g></g></svg>
            `;}
            if (name == "liveChat") {
                return `<svg height="55px" width="60px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.052 512.052" style="enable-background:new 0 0 512.052 512.052;" xml:space="preserve"> <path style="fill:#64B5F6;" d="M467.526,428.926c28.8-30.9,44.5-69.1,44.5-108.9c0-49.8-24.6-94.9-64-126.9 c-0.9,114.1-108.2,206.9-240,206.9h-89.2c34.5,56.9,104.6,96,185.2,96h192c6.5,0,12.3-3.9,14.8-9.9c2.5-6,1.1-12.9-3.5-17.4 L467.526,428.926z"/> <path style="fill:#2196F3;" d="M208.026,16.026c-114.7,0-208,78.9-208,176c0,39.8,15.7,77.9,44.5,108.9l-39.8,39.8 c-4.6,4.6-6,11.5-3.5,17.4c2.5,6,8.3,9.9,14.8,9.9h192c114.7,0,208-78.9,208-176S322.726,16.026,208.026,16.026z"/> <g> <path style="fill:#FAFAFA;" d="M304.026,144.026h-192c-8.8,0-16,7.2-16,16s7.2,16,16,16h192c8.8,0,16-7.2,16-16 S312.826,144.026,304.026,144.026z"/> <path style="fill:#FAFAFA;" d="M240.026,208.026h-128c-8.8,0-16,7.2-16,16s7.2,16,16,16h128c8.8,0,16-7.2,16-16 S248.826,208.026,240.026,208.026z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>`;}
            if (name == "upload") {
                    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="28" height="28" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m432 0h-352c-44.113281 0-80 35.886719-80 80v280c0 44.113281 35.886719 80 80 80h273c11.046875 0 20-8.953125 20-20s-8.953125-20-20-20h-73.664062l-45.984376-59.65625 145.722657-185.347656 98.097656 108.421875c5.546875 6.136719 14.300781 8.21875 22.019531 5.246093 7.714844-2.976562 12.808594-10.394531 12.808594-18.664062v-170c0-44.113281-35.886719-80-80-80zm40 198.085938-79.167969-87.503907c-3.953125-4.371093-9.640625-6.785156-15.523437-6.570312-5.886719.207031-11.386719 2.996093-15.03125 7.628906l-154.117188 196.023437-52.320312-67.875c-3.785156-4.910156-9.636719-7.789062-15.839844-7.789062-.003906 0-.007812 0-.011719 0-6.203125.003906-12.058593 2.886719-15.839843 7.804688l-44.015626 57.21875c-6.734374 8.757812-5.097656 21.3125 3.65625 28.046874 8.757813 6.738282 21.3125 5.097657 28.050782-3.65625l28.175781-36.632812 88.816406 115.21875h-148.832031c-22.054688 0-40-17.945312-40-40v-280c0-22.054688 17.945312-40 40-40h352c22.054688 0 40 17.945312 40 40zm0 0" fill="#7e7e7e" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m140 72c-33.085938 0-60 26.914062-60 60s26.914062 60 60 60 60-26.914062 60-60-26.914062-60-60-60zm0 80c-11.027344 0-20-8.972656-20-20s8.972656-20 20-20 20 8.972656 20 20-8.972656 20-20 20zm0 0" fill="#7e7e7e" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m468.476562 302.941406c-.058593-.058594-.117187-.121094-.175781-.179687-9.453125-9.519531-22.027343-14.761719-35.410156-14.761719-13.34375 0-25.882813 5.210938-35.324219 14.675781l-38.613281 38.085938c-7.863281 7.753906-7.949219 20.417969-.191406 28.28125 7.753906 7.863281 20.417969 7.953125 28.28125.195312l25.847656-25.492187v112.253906c0 11.046875 8.953125 20 20 20s20-8.953125 20-20v-111.644531l24.738281 25.554687c3.921875 4.054688 9.144532 6.089844 14.371094 6.089844 5.011719 0 10.027344-1.871094 13.910156-5.628906 7.9375-7.683594 8.140625-20.34375.457032-28.28125zm0 0" fill="#7e7e7e" data-original="#000000" style="" class=""/></g></svg>
            `;}
            if (name == "sendBtn") {
                    return `<svg viewBox="0 0 24 24" width="20" height="20" class=""><path fill="#4F5458" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path></svg>
            `;}
            if (name == "recordBtn") {
                return `<svg viewBox="0 0 24 24" width="24" height="24" class=""><path fill="#4F5458" d="M11.999 14.942c2.001 0 3.531-1.53 3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531S8.469 2.35 8.469 4.35v7.061c0 2.001 1.53 3.531 3.53 3.531zm6.238-3.53c0 3.531-2.942 6.002-6.237 6.002s-6.237-2.471-6.237-6.002H3.761c0 4.001 3.178 7.297 7.061 7.885v3.884h2.354v-3.884c3.884-.588 7.061-3.884 7.061-7.885h-2z"></path></svg>
           `;} 
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async uploadImage(event) {
                event.target.files.forEach(async(ele) => {
                     await this.getBase64(ele).then(
                            async (data) => {
                                this.uploadedImages.push(data)
                            })
                })          
        },
        async getImageCDN(file){
            try {
                var res=await this.$server.create('medias',{picture:file})
               return res.content.message
            } catch (error) {
                console.log('err',error);
            }
        },
        async getAudioCDN(file){
            try {
                var res=await this.$server.create('medias',{picture:file})
               return res.content.message
            } catch (error) {
                console.log('err',error);
            }
        },
        firstMessages(){
            this.messages.push({
                type:"text",
                message:`Hi how we can help you.`,
                admin: true,
                from: "admin",
                to: "",
                adminName:"Shippsen",
                timestamp:Date.now()-(1000*60*5),
                readedByVisitor: false,
                readedByAdmin: true,
            });
            this.messages.push({
                type:"text",
                message:`Salut comment pouvons-nous vous aider.`,
                admin: true,
                from: "admin",
                to: "",
                adminName:"Shippsen",
                timestamp:Date.now()-(1000*60*5),
                readedByVisitor: false,
                readedByAdmin: true,
            });
            this.messages.push({
                type:"text",
                message:`.مرحبا كيف يمكننا مساعدتك`,
                admin: true,
                from: "admin",
                to: "",
                lang: "ar",
                adminName:"Shippsen",
                timestamp:Date.now()-(1000*60*5),
                readedByVisitor: false,
                readedByAdmin: true,
            });
        },
        getfirebase(firebaseConfig) { 
            return new Promise(async(resolve) => {
              try{
                  if (firebase.apps.length > 0) {} else {
                      await firebase.initializeApp(firebaseConfig)
                  }
                  resolve({ firebase });
              }catch(err){
                  console.log("Err--------- : ",err);
              }
            });    
        },
    }
}
</script>
<style scoped>
.shep{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: 5px 0;
    overflow: hidden;
    background: #fff;
    padding: 2px;
    box-shadow: 1px 1px 3px #9c9c9c;
}
.scroll-box::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0 #F8F9FD;
    box-shadow: inset 0 0 0 #F8F9FD;
}

.scroll-box::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

.scroll-box::-webkit-scrollbar-thumb {
    border-radius: 1.5rem;
    background-color: #001f3f;
}
.messages-box .msg .message-options{
    position: absolute;
    right: -12px;
    box-shadow: 0 0 3px 1px #00000014;
    border-radius: 3px;
    text-align: center;
    padding-top: 4px;
    transition: all .5s ease;
    top: 0;
    z-index: 2;
    height: 30px;
    width: 120px;
    background-color: #FFF;
}

@keyframes record {
    0% { background-color: rgba(95, 146, 155, 0.3); }
    25% { background-color:rgba(163, 227, 238, 0.2); }
    50% { background-color:rgba(238, 238, 238, 0); }
    75% { background-color:rgba(160, 174, 177, 0.2); }
    100% { background-color: rgba(121, 167, 175, 0.3); }
}
@keyframes record-bounce {
  0% { transform: scale(1); opacity: 1 }
  25% { transform: scale(0.8); opacity: .5; }
  50% { transform: scale(0.7); opacity: 0; }
  75% { transform: scale(0.8) ; opacity: .5;}
  100% { transform: scale(1) ; opacity: 1;}
}
@keyframes button-loading {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}
.record-animation{
    animation: record 3s linear infinite!important;
}
.scroll-box::-webkit-scrollbar:hover {
    width: 10px;
}
.chat-container {
    position: fixed;
    z-index: 99999999999;
    /* top: 50px; */
    /* right: 150px; */
    height: 60vh;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    background-color: rgba(235, 240, 245, 0.01);
}

.chat-box {
    width: 300px;
    position: relative;
    overflow: hidden;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    height: 100%;
    border-radius: 10px;
    border-radius: 10px;
    border-color: #7367f0;
    max-height: 550px;
    box-shadow: 1px 9px 22px -6px #c3c3c3;
}
/*chat-box 1/2 */
.chat-box .chat-header {
    box-shadow: 1px 4px 31px -11px #ccc;
    z-index: 9;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    padding: 8px 5px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}
.profile-image {
    position: relative;
    width: 30px;
    height: 30px;
}

.profile-image img {
    width: 30px;
    height: 30px;
    border-radius: 40px;
}

.profile-image .account-status {
    position: absolute;
    right: 1px;
    bottom: 3px;
    width: 9px;
    height: 9px;
    border-radius: 20px;
    background: #28C76F;
}
.flex-left{
    display: flex;
}
.chat-header .chat-title {
    font-size: 16px;
    padding: 2px 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    margin: 0;
}

/*chat-box 2/2 */
.chat-box .messages-box {
    background: linear-gradient(to right,#1111110d,#ffffff00),url(https://storeno.b-cdn.net/stores/6-2021/1622561368276.jpeg);
    max-width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    padding: 5px 15px;
    display: flex;
    flex-direction: column;
}
.messages-box .msg {
    height: auto;
    transition: 0.8s ease;
    margin-bottom: 5px;
    position: relative;
}

.messages-box .uploader-image{
    position: absolute;
    display: flex;
    justify-content: space-between;
    bottom: 42px;
    width: calc(100% - 17px);
    height: 200px;
    left: 9px;
    padding: 5px 10px;
    background-color: #FFF;
    box-shadow: 0 0 3px rgb(185 179 179);
    border-radius: 5px;
}
.images-slied {
    display: flex;
    width: calc(100% - 50px);
    overflow-x: auto;
}


.messages-box .uploader-image img{
    object-fit: contain;
    margin: 0 10px;
  
}
.container-send-box{
    height: 50px;
    margin-top: 1px;
    padding: 2px 5px;
    display: flex;
    align-items: center;
    background-color: #FFF;
}
.container-send-box-start{
    position: absolute;
    bottom: 15px;
    right: 2px;
    left: 2px;
    height: 50px;
    margin-top: 1px;
    padding: 2px 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.container-send-box-start button{
    padding: 10px 40px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 3px 1px #00000061;
    color: #323038;
    border-radius: 50px;
    cursor: pointer;
    font-size: 25px;
    border: none;
}
.bg-col{
    border-radius: 25px;
    background-color: rgb(241, 241, 241);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 5px 0 2px;
    position: relative;
}
.record-actions{
    display: flex;
    border-radius: 25px;
    background-color: rgb(241, 241, 241);
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: absolute;  
}
.message-send-box {
    border-radius: 25px;
    background-color: rgb(241, 241, 241);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2px 0 8px;
    margin: 0;
    width: calc(100% - 64px);

}
.wrapper .file-upload span{
    height: 26px;
    display: flex;
    align-items: center;
    padding-top: 6px;
}

.message-send-box .message-send {
    font-size: 13px;
    height: 30px;
    width: calc(100% - 40px);
    border: none;
    background:none;

}
.message-send-box .message-send:focus {
    outline: none;
}
.send-button {
    position: relative;
    overflow: hidden;
    min-width: 26px;
    height: 26px;
    border: none;    
    background-color: #FFF;
    cursor: pointer;
    background-color: rgb(241, 241, 241);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: ease .4s;
}
.send-button-img{
    width: 32px;
    height: 32px;
}
.absolute-r-2{
    position:absolute;
    right:2px;
}
.send-button:hover {
    background-color: rgb(238, 236, 236);
}
.send-button span {
    display: flex;
    align-items: center;
    justify-content: center;
}
.send-button .loader {
    background: rgb(111 157 174);
    position: absolute;
    z-index: 2;
    height: 30px;
    width: 30px;
    border-radius: 50px;
}
.send-button .loader::after {
  content: "";
  position: absolute;
  width: 15px;
  height: 15px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 4px solid transparent;
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: button-loading 1s ease infinite;
}
.intra-space{
    margin-right: 4px;
}
/* uplodrer */
.wrapper {
  height: 30px;
}
.wrapper .file-upload {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .5s;
}
.wrapper .file-upload input[type=file] {
  height: 28px;
  width: 28px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrapper .file-upload>svg {
  margin-top: 5px;
}
.wrapper:hover {
  box-sizing: 0 2px 2px rgb(216, 54, 54);
  cursor: pointer;
}
.close-icon{
    height: 27px;
    width: 28px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.close-icon:hover{
    background-color: #e7e5eb;
}
.close-icon .bar{
    background-color: #827896;
    height: 2px;
    width: 15px;
    position: absolute;
}
.close-icon .bar:first-child{
    transform: rotate(45deg);
}
.close-icon .bar:last-child{
    transform: rotate(-45deg);
}

.popup .bar,.uploader-image .bar{
    background-color: rgb(72, 98, 100);
    height: 3px;
    width: 17px;
    position: absolute;
}
/*  */
.popup  .bar:first-child,.uploader-image  .bar:first-child {
    transform: rotate(45deg);
}
.popup  .bar:last-child,.uploader-image  .bar:last-child {
    transform: rotate(-45deg);
}

.messages-box .uploader-image .actions{
  display: flex;
  flex-direction:column;
  align-items: flex-end;
  justify-content: space-between;
}
.bs2b{
  border: solid 2px #61AFC7!important;
  margin-right: 5px;
}
.bs2b:hover>svg{
  fill:#e8e8e8!important;
}

.bs2b:hover{
  border: none;
  background-color: #61AFC7!important;
}
.remove-audio{
    border: solid 2px #EF6868;
    box-sizing:border-box
}
.remove-audio:hover{
    /* border: solid 2px #fff; */
    background: #EF6868;
}
.remove-audio:hover svg {
    color: #FFF!important;
}
.timer-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:0 4px;
}
.timer{
    width: 55px;
    font-size: 14px;
    color: rgb(118 118 118);
    padding: 0 5px;
    font-weight: 500;
}
.timer-circle{
    width: 12px;
    height: 12px;
    background: rgb(246, 57, 57);
    border-radius: 50%;
}
.bounce-animation{
    animation: record-bounce 1.2s ease infinite;
}

</style>